module.exports = __webpack_public_path__ + "img/img_card_error_02@2x.b72031e6.png";